module.exports = {"id":"228666","name":"Brandley Kuwas","rating":"75","photo":"./data/images/photos/0/228666.png","club":{"name":"Heracles Almelo","logo":"./data/images/clubs/HeraclesAlmelo.png"},"positions":["AD"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/BrandleyKuwas0.json
// module id = 639
// module chunks = 0